export const FILE_STATUS_INTERVAL = 15000;
export const APPROVAL_STATUS_INTERVAL = 10000;
export const NOTE_CHARACTER_LIMIT = 1500;
export const ROWS_PER_PAGE = 10;
export const APPLY_DEFAULT_FILTER = false;

export const DATA_STATUS = [
  "Ready for Review",
  "In Review",
  "Approved",
  "Unapproved",
  "Not ready for review",
];

export const DATA_SOURCES = ["UCS", "UBS", "WBS", "TFF", "NA"];

export const DOCUMENTS = [
  {
    name: "Understanding Tactical PIM DevOPS",
    url: "https://unfi.sharepoint.com/:b:/r/sites/P-37065-IT/Shared%20Documents/Data%20Enrichment/Training%20and%20Handover/DevOps_TechnicalSession1_23March2023.pdf?csf=1&web=1&e=t23Q4U",
  },
  {
    name: "Tactical PIM User Guide",
    url: "https://unfi.sharepoint.com/:b:/r/sites/P-37065-IT/Shared%20Documents/Data%20Enrichment/Training%20and%20Handover/UNFI%20System%20features%20and%20Capabilities%20End-to-End%20User%20guide%20V0.06.pdf?csf=1&web=1&e=GNiM8P",
  },
  {
    name: "Input Source File Template",
    url: "https://unfi.sharepoint.com/:x:/r/sites/P-37065-IT/Shared%20Documents/Data%20Enrichment/Training%20and%20Handover/Source%20File%20Input%20Template.xlsx?d=w1dcd01f11caf45a0ab91a2820c18972c&csf=1&web=1&e=uoVrJ2",
  },
  {
    name: "Supplier File Template",
    url: "https://unfi.sharepoint.com/:x:/r/sites/P-37065-IT/Shared%20Documents/Data%20Enrichment/Training%20and%20Handover/Source%20File%20Input%20Template.xlsx?d=w1dcd01f11caf45a0ab91a2820c18972c&csf=1&web=1&e=uoVrJ2",
  },
  {
    name: "Business Validations",
    url: "https://unfi.sharepoint.com/:w:/r/sites/P-37065-IT/Shared%20Documents/Data%20Enrichment/Training%20and%20Handover/File%20and%20Field%20Validations.docx?d=w9e213e1127e44be882cd1a0788ac15cd&csf=1&web=1&e=RLZEgO",
  },
  {
    name: "Steps for data migration from one UNFI environment to another",
    url: "https://unfi.sharepoint.com/:w:/r/sites/P-37065-IT/Shared%20Documents/Data%20Enrichment/Training%20and%20Handover/Tactical-PIM_CrossAccount_DataMigration_Steps.docx?d=w24b2b66a7de84f56919cc95a35be8431&csf=1&web=1&e=SzZY0Q",
  },
  {
    name: "Tactical PIM Architecture",
    url: "https://unfi.sharepoint.com/:w:/r/sites/P-37065-IT/Shared%20Documents/Data%20Enrichment/Training%20and%20Handover/Tactical-PIM_Architecture.docx?d=w68e6a4f4032c43b3898cf7c823df22e7&csf=1&web=1&e=QnPlS3",
  },
  {
    name: "Tactical PIM Backend Resources Overview",
    url: "https://unfi.sharepoint.com/:w:/r/sites/P-37065-IT/Shared%20Documents/Data%20Enrichment/Training%20and%20Handover/Tactical%20PIM%20backend%20resources.docx?d=w3ea8bb03a3bd4a4fa8486aeea125ca25&csf=1&web=1&e=wpd3In",
  },
  {
    name: "Tactical PIM Documentation Confluence",
    url: "https://unfisc.atlassian.net/wiki/spaces/MSC/pages/3651960897/Product+Enrichment+Tactical+Documentation",
  },
  {
    name: "How to run CDK scripts locally",
    url: "https://unfi.sharepoint.com/:w:/r/sites/P-37065-IT/Shared%20Documents/Data%20Enrichment/Training%20and%20Handover/CDK%20Local%20Set%20up.docx?d=w67925f9a2b8f43acace4c12a6e4fed03&csf=1&web=1&e=8abDrv",
  },
  {
    name: "Tactical PIM Front End Code Overview",
    url: "https://unfi.sharepoint.com/:w:/r/sites/P-37065-IT/Shared%20Documents/Data%20Enrichment/Training%20and%20Handover/Helpmate-UNFI-Frontend.docx?d=wb2babd90f7f5456da8dddfa07d6df4bf&csf=1&web=1&e=B5Xm6H",
  },
];
